module.exports = "img/flags/CD.3f8ba92.png";